<script setup>
import SportLiveTvDialog from '@/sport-live-tv/components/sport-live-tv-dialog.vue';
import SportLiveTvStreamOption from '@/sport-live-tv/components/sport-live-tv-stream-option.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

defineProps({
  subtitle: { type: String, default: '' },
  sources: { type: Array, required: true },
});

const emit = defineEmits(['select']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <SportLiveTvDialog>
    <div class="sport-live-tv-stream-picker__header">
      <h2 class="sport-live-tv-stream-picker__title">{{ t('chooseStream') }}</h2>
      <p class="sport-live-tv-stream-picker__subtitle">{{ subtitle }}</p>
    </div>
    <div class="sport-live-tv-stream-picker__options">
      <SportLiveTvStreamOption v-for="(source, index) in sources" :key="source.epgId" :source="source" :recommended="index === 0" @select="emit('select', $event)" />
    </div>
    <p class="sport-live-tv-stream-picker__hint">{{ t('chooseStreamHint') }}</p>
  </SportLiveTvDialog>
</template>

<style lang="scss" scoped>
.sport-live-tv-stream-picker {
  &__header,
  &__options {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    margin: 0;
    color: $white;
    font-size: 20px;
    font-weight: 600;
  }

  &__subtitle,
  &__hint {
    margin: 0;
    color: $gray;
    font-size: 13px;
  }
}
</style>
